import { deserializeEMR, type EMRInfo, type EMRInfoJSON, serializeEMR } from './_EMR.ts'
import { type AppointmentInfo, type AppointmentInfoJSON, deserializeAppointmentInfo, serializeAppointmentInfo } from './Appointment.ts'
import { type CareInfo, type CareInfoJSON, deserializeCareInfo, serializeCareInfo } from './Care.ts'
import { type ProductID } from './ServiceProduct.ts'
import { deserializeUserProfileContent, serializeUserProfileContent, type UserProfileContent, type UserProfileContentJSON } from './UserProfile.ts'
import { deserializeUserSurgeryInterestContent, serializeUserSurgeryInterestContent, type UserSurgeryInterestContent, type UserSurgeryInterestContentJSON } from './UserSurgeryInterest.ts'

export interface AppConfig {
	testMode: boolean
	stripePublishableKey: string
	enableSurgeries: boolean
}

export interface FatUser {
	appConfig: AppConfig

	userProfile?: UserProfileContent | null
	userSurgeryInterest?: UserSurgeryInterestContent | null
	appointments?: AppointmentInfo[]
	inventory?: ProductID[]
	care?: CareInfo
	emrs?: EMRInfo[]
}

export interface FatUserJSON {
	appConfig: AppConfig

	userProfile?: UserProfileContentJSON | null
	userSurgeryInterest?: UserSurgeryInterestContentJSON | null
	appointments?: AppointmentInfoJSON[]
	inventory?: ProductID[]
	care?: CareInfoJSON
	emrs?: EMRInfoJSON[]
}

export function serializeFatUser(data: FatUser): FatUserJSON {
	return {
		...data,
		userProfile: !data.userProfile ? data.userProfile : serializeUserProfileContent(data.userProfile),
		userSurgeryInterest: !data.userSurgeryInterest ? data.userSurgeryInterest : serializeUserSurgeryInterestContent(data.userSurgeryInterest),
		appointments: !data.appointments ? data.appointments : data.appointments.map(serializeAppointmentInfo),
		care: !data.care ? data.care : serializeCareInfo(data.care),
		emrs: !data.emrs ? data.emrs : data.emrs.map(serializeEMR),
	}
}

export function deserializeFatUser(data: FatUserJSON): FatUser {
	return {
		...data,
		userProfile: !data.userProfile ? data.userProfile : deserializeUserProfileContent(data.userProfile),
		userSurgeryInterest: !data.userSurgeryInterest ? data.userSurgeryInterest : deserializeUserSurgeryInterestContent(data.userSurgeryInterest),
		appointments: !data.appointments ? data.appointments : data.appointments.map(deserializeAppointmentInfo),
		care: !data.care ? data.care : deserializeCareInfo(data.care),
		emrs: !data.emrs ? data.emrs : data.emrs.map(deserializeEMR),
	}
}
